module.exports = "https://r.nearpod.com/assets/media/image/web-content-02bdbbc70cfc284a8068e3ccb352637e.svg";